const content: { [key: string]: any } = {
  personal: {
    title: "Personal Bonus",
    titleMobile: "Personal Performance Bonus",
    subTitle:
      "Your personal bonus is the total earnings from your purchases as well as from your customers and members.",
    table: {
      personalBV: "Personal BV",
      bonusPercent: "Performance Bonus",
      personalBonusAmount: "Current Personal Bonus Total",
      nonBonusable: "Non-bonusable Personal BV",
    },
  },
  differential: {
    title: "Differential Bonus",
    titleMobile: "Differential Performance Bonus",
    subTitle:
      "Your Differential Multiplier is the <1>difference between your performance bonus level and your frontline's performance bonus level.</1>",
    zeroAmountText:
      'Differential Performance Bonus is one of the most important Core Plan bonuses Amway has to offer.<br><br>As your business starts to grow and you focus on width and depth and volume pass-up, you can reach higher levels on the Performance Bonus schedule.<br><br>Differential is determined by the difference between your Performance Bonus level and the Performance Bonus level from each of your Line of Sponsorship (LOS) legs. A simple example is if you\'re at 9% Performance Bonus and one of your legs is at 3% Performance Bonus, you earn 6% "differential" paid on the total Business Volume (BV) passing up to you from that leg.',
    zeroAmountTextMobile:
      'Differential Performance Bonus is one of the most important Core Plan bonuses Amway has to offer. As your business starts to grow and you focus on width and depth and volume pass-up, you can reach higher levels on the Performance Bonus schedule. Differential is determined by the difference between your Performance Bonus level and the Performance Bonus level from each of your Line of Sponsorship (LOS) legs. A simple example is if you\'re at 9% Performance Bonus and one of your legs is at 3% Performance Bonus, you earn 6% "differential" paid on the total Business Volume (BV) passing up to you from that leg',
    table: {
      aboBonusPercent: "{aboBonusPercent} Performance Bonus",
      aboGpv: "{aboGpv} GPV",
      personalBV: "Group BV ({countryCode})",
      bonusPercent: "Differential Multiplier ({bonusPercent})",
      personalBonusAmount: "Current Differential Total",
      nonBonusable: "Non-bonusable Leg BV",
      total: "Differential Bonus Total",
    },
    exportTitle: "Export",
  },
};

export default content;
